import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import InformationcircleIcon from 'icons/Informationcircle.icon';
import ResolvePopup from 'components/ResolvePopup';
import CheckIcon from 'icons/Check.icon';

import './FileSecurityFeatureList.styles.scss';

export type FileSecurityLevelListItem = {
  label: string;
  popupContent?: React.ReactNode;
};

type FileSecurityFeatureListProps = {
  className?: string;
  list: FileSecurityLevelListItem[];
};

const FileSecurityFeatureList: React.FC<FileSecurityFeatureListProps> = (
  props,
) => {
  const { className, list } = props;

  const { t } = useTranslation();

  return (
    <ul className={classNames('file-security-feature-list', className)}>
      {list.map(({ label, popupContent }) => (
        <li key={label}>
          <CheckIcon />
          <span>{t(label)}</span>

          {popupContent && (
            <ResolvePopup onHover popupContent={popupContent}>
              <InformationcircleIcon />
            </ResolvePopup>
          )}
        </li>
      ))}
    </ul>
  );
};

export default FileSecurityFeatureList;
